import { gql } from 'apollo-angular';

const LOAD_PURCHASE_PLAN = gql`
  mutation loadPlan($activePurchasePlanId: Long!,$loadPlanRequest: LoadPurchasePlanRequest!) {
    loadPlan(
      activePurchasePlanId: $activePurchasePlanId, 
      loadPlanRequest: $loadPlanRequest ) 
        {
        success
      }
  }
`;

export default LOAD_PURCHASE_PLAN;
